import {Component} from '@angular/core';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {IBaseModalComponent} from '../../components/ibase-modal/ibase-modal.component';
import {PrimeNgImportsModule} from '../../prime-ng-imports';

/**
 * Re-enforced confirmation dialog configuration
 */
export class ReenforcedConfirmModalConfig {
    constructor(
        public isCreate: boolean,
        public message: string,
        public confirmation: string
    ) {}
}

/**
 * Re-enforced confirmation dialog component
 */
@Component({
    selector: 'app-reenforced-confirm-modal',
    templateUrl: './reenforced-confirm-modal.component.html',
    styleUrls: ['./reenforced-confirm-modal.component.scss'],
    imports: [PrimeNgImportsModule]
})
export class ReenforcedConfirmModalComponent extends IBaseModalComponent<
    ReenforcedConfirmModalComponent,
    ReenforcedConfirmModalConfig
> {
    protected confirmation = '';
    protected confirmationInput = '';

    // ===============================================================
    // ===============================================================

    /**
     * Get dialog service parameters
     * @param dialogOpenMode Dialog open mode
     * @param extended Extended config
     * @returns DynamicDialogConfig<ReenforcedConfirmDialogConfig>
     */
    public static getDialogServiceParameters(
        config: ReenforcedConfirmModalConfig
    ): DynamicDialogConfig<ReenforcedConfirmModalConfig> {
        return {
            modal: true,
            header: config.isCreate ? 'Creation confirmation' : 'Deletion confirmation',
            data: config
        };
    }

    // ===============================================================
    // ===============================================================

    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    protected override async onReady(): Promise<void> {
        this.confirmation = this.config.data?.confirmation ?? '<unk>';
        this.confirmationInput = '';
    }
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}

    // ===============================================================
    // ===============================================================

    /**
     * On cancel button
     */
    protected onCancel() {
        this.ref.close(false);
    }
    /**
     * On confirm button
     */
    protected onConfirm() {
        if (this.confirmation != this.confirmationInput) return;

        this.ref.close(true);
    }
}
